import React, { useEffect, useState } from 'react';
import "./css/Previewer.css";
import $ from 'jquery';

let previewerInterval;

export function Previewer({ shown, pictures, close }) {

    const [hovering, setHovering] = useState(false);
    const [image, setImage] = useState(null);
    const [playingIndex, setPlayingIndex] = useState("loading...");

    useEffect(() => {
        if (shown) {
            showPreviewer();
        }
    }, [shown])

    function showPreviewer() {
        $('#previewer-container').fadeIn(300);
        $('#previewer-container').css('display', 'flex');
        $('#previewer').css({ "margin-left": "2000px" }).animate({ "margin-left": "0px" }, 300)
        setImage(null);
        setPlayingIndex("loading...");
        let i = 0;
        if (!pictures.length) {
            setPlayingIndex("no pictures");
            return;
        }
        previewerInterval = setInterval(() => {
            setPlayingIndex(`${i + 1}/${pictures.length}`);
            setImage(pictures[i].imageSrc);
            i++;
            if (i == pictures.length)
                i = 0;
        }, 1000);
    }

    function closePreviewer() {
        $('#previewer-container').fadeOut(300);
        $('#previewer').css("margin-left", "0px")
            .animate({ "margin-left": "2000px" }, 300);
        close();
        clearInterval(previewerInterval);
    }

    return (
        <div className="previewer-container" id="previewer-container" onClick={() => { closePreviewer() }}>
            <div className="previewer" id="previewer" onClick={(e) => { e.stopPropagation() }}>
                <div className="top-bar">
                    <img src={hovering ? "icons/close-white.svg" : "icons/close.svg"} className="close"
                        onClick={(e) => { closePreviewer() }}
                        onMouseOver={() => { setHovering(true) }}
                        onMouseOut={() => { setHovering(false) }}
                    />
                </div>
                <div className="frame-background">
                    <img className="frame" id="frame" src={image} />
                </div>
                <div className="preview-tool">
                    <img src="icons/arrow-left.svg" className="arrow" />
                    <div className="text" id="playing-picture">
                        {playingIndex}
                    </div>
                    <img src="icons/arrow-left.svg" className="arrow" style={{ transform: "rotate(180deg)" }} />
                </div>
            </div>
        </div>
    );
}
